import { render, staticRenderFns } from "./ConversationModal.vue?vue&type=template&id=c5d5a84c"
import script from "./ConversationModal.vue?vue&type=script&lang=js"
export * from "./ConversationModal.vue?vue&type=script&lang=js"
import style0 from "./ConversationModal.vue?vue&type=style&index=0&id=c5d5a84c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports